const site = process.env.SITE_NAME || 'sd'
let siteConfig = require(`./${site}.js`)
export const getSiteConfig = () => {
    return siteConfig.default
}

